import React from "react";
import { Modal } from "react-bootstrap";
import Close from "../../../Helpers/CloseBtn/Close";
import PopupTitle from "../../../Helpers/Popup/PopupParts/PopupTitle";
import Popup from "../../../Helpers/Popup/Popup";
import Button from "../../../Helpers/Button/Button";
import RequestPopupBody from "./RequestPopupBody";

const RequestPopup = ({ id, onClose, title }) => {
  return (
    <Popup size={"lg"} show={!!id}>
      {/* {isLoading && (
        <div className="loader-container">
          <Loader />
        </div>
      )} */}
      <Modal.Header className="modal-header flex-between">
        <Modal.Title id="contained-modal-title-vcenter">
          <PopupTitle headtitle={`Maintenance Request`} subtitle={title} />
        </Modal.Title>
        <div className="flex-row gap-16">
          <Close style="close-32 close" close={() => onClose()} img="Close" />
        </div>
      </Modal.Header>
      <Modal.Body className="modal-body-scrollable">
        <RequestPopupBody />
      </Modal.Body>
      <Modal.Footer>
        <Button
          type="default"
          htmlType="button"
          text="Reject"
          onClick={() => onClose()}
        />
        <Button
          text="Approve"
          htmlType="submit"
          type="primary"
        />
      </Modal.Footer>
    </Popup>
  );
};

export default RequestPopup;
